// Home FAQ accordion scaffold (expand/collapse common questions).
import { useState } from "react";
import Container from "../../layout/Container";
import { useLanguage } from "../../../i18n/LanguageContext";

export default function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState(null);
  const { t, lang } = useLanguage();
  const faqData = t.home.faq.items;

  // Toggle the clicked question
  const handleToggle = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <section
      className="faq-section"
      data-aos="fade-up"
      dir={lang === "ar" ? "rtl" : "ltr"}
    >
      <Container>
        <h2 className="faq-section__title">{t.home.faq.title}</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? "faq-item--open" : ""}`}
          >
            <button
              className="faq-question"
              onClick={() => handleToggle(index)}
              aria-expanded={openIndex === index}
            >
              <span>{item.q}</span>

              <svg
                className={`faq-arrow ${openIndex === index ? "faq-arrow--open" : ""}`}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

            <div className={`faq-answer ${openIndex === index ? "faq-answer--open" : ""}`}>
              <p>{item.a}</p>
            </div>
          </div>
        ))}
      </Container>
    </section>
  );
}